const configStoreModule = process.env.NODE_ENV === 'production'
  ? require('./store/store.prod')
  : require('./store/store.dev');

export default configStoreModule.default();
